import ProductEdit from '../components/ProductEdit'
import React from 'react'

function ProductEditPage() {

  return (
    <div>
     <ProductEdit/>
    </div>
  )
}

export default ProductEditPage
